import { addDays } from 'date-fns';

export const getUpcomingSessionShortcuts = () => {
  const today = new Date();

  return [
    {
      label: 'Today',
      getValue: () => [today, today] as [Date, Date],
    },
    {
      label: 'Next 7 days',
      getValue: () => [today, addDays(today, 7)] as [Date, Date],
    },
    {
      label: 'Next 14 days',
      getValue: () => [today, addDays(today, 14)] as [Date, Date],
    },
    {
      label: 'Next 30 days',
      getValue: () => [today, addDays(today, 30)] as [Date, Date],
    },
  ];
};

export const UPCOMING_SESSIONS_KPI_RANGE_OPTIONS = [
  { value: 'today', label: 'Today', sort: 0 },
  { value: 'next7Days', label: 'Next 7 Days', sort: 1 },
  { value: 'nextWeek', label: 'Next Week', sort: 2 },
  { value: 'next30Days', label: 'Next 30 Days', sort: 3 },
  { value: 'nextMonth', label: 'Next Month', sort: 4 },
  { value: 'nextQuarter', label: 'Next Quarter', sort: 5 },
];
